import React, { useEffect, useState, useMemo } from "react";
import "./style.css";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import AxiosController from "../../../../authentication/AxiosController";
import Loader from "../../../../loader/Loader";
import PaymentRequestsTableRow from "./PaymentRequestsTableRow";
import { Helmet } from "react-helmet";
import { LuTruck, LuPackage, LuTrendingUp } from "react-icons/lu";

const fetchPaymentRequests = (
  slug,
  lang,
  token,
  handleOrdersData,
  page,
  handleLoader
) => {
  AxiosController.get(`api/${slug}/${lang}/products-pickup/`, {
    headers: { Authorization: `Bearer ${token}` },
  })
    .then((res) => {
      handleOrdersData(res);
      handleLoader(false);
    })
    .catch((e) => {
      handleLoader(false);
    });
};

const fetchPickUpNumber = (slug, lang, token, handleOrdersData) => {
  AxiosController.get(`api/${slug}/${lang}/orders/counter/ready-confirmed`, {
    headers: { Authorization: `Bearer ${token}` },
  })
    .then((res) => {
      handleOrdersData(res.data);
    })
    .catch((e) => {});
};

const PickupReport = () => {
  const { slug, lang } = useParams();
  const [_] = useTranslation("global");
  const token = localStorage.getItem("token");
  const [paymentRequests, handlePaymentRequests] = useState();
  const [counter, setCounter] = useState([]);
  const [page, handlePage] = useState(1);
  const [loading, handleLoader] = useState(false);

  useEffect(() => {
    handleLoader(true);
    fetchPaymentRequests(
      slug,
      lang,
      token,
      handlePaymentRequests,
      page,
      handleLoader
    );
    fetchPickUpNumber(slug, lang, token, setCounter);
  }, [token, slug, lang, page, handleLoader]);

  // Compute metrics for Egapy-style summary cards
  const metrics = useMemo(() => {
    const totalOrders = Array.isArray(counter)
      ? counter.reduce((prv, c) => (c?.count || 0) + prv, 0)
      : 0;
    const productsList = paymentRequests?.data?.[0] || [];
    const totalProducts = productsList.length;
    const totalPieces = productsList.reduce(
      (sum, item) => sum + (parseInt(item.total_quantity) || 0),
      0
    );

    return { totalOrders, totalProducts, totalPieces };
  }, [counter, paymentRequests]);

  return (
    <div className="pickup-report-wrapper position-relative px-2">
      <Helmet>
        <title>{_("panel.pickupReport")}</title>
      </Helmet>
      <Loader active={loading} />

      {/* Header */}
      <div className="d-flex align-items-center justify-content-between mb-3 mt-2">
        <h3 className="pickup-header-title">
          <LuTruck size={30} />
          <span>{_("panel.pickupReport")}</span>
        </h3>
      </div>

      {/* Egapy Top Metric Cards Grid */}
      <div className="pickup-metrics-grid">
        {/* Total Orders Card */}
        <div className="pickup-metric-card">
          <div className="pickup-metric-header">
            <span className="pickup-metric-title">
              {_("panel.totalorders") || (lang === "ar" ? "إجمالي الطلبات" : "Total Orders")}
            </span>
            <div
              className="pickup-metric-icon-box"
              style={{
                backgroundColor: "rgba(89, 198, 201, 0.15)",
                color: "#59c6c9",
              }}
            >
              <LuTruck size={20} />
            </div>
          </div>
          <div className="pickup-metric-value">
            {loading && !paymentRequests ? "…" : metrics.totalOrders}
          </div>
        </div>

        {/* Total Unique Products Card */}
        <div className="pickup-metric-card">
          <div className="pickup-metric-header">
            <span className="pickup-metric-title">
              {lang === "ar" ? "عدد المنتجات" : "Total Products"}
            </span>
            <div
              className="pickup-metric-icon-box"
              style={{
                backgroundColor: "rgba(243, 168, 55, 0.15)",
                color: "rgb(243, 168, 55)",
              }}
            >
              <LuPackage size={20} />
            </div>
          </div>
          <div className="pickup-metric-value">
            {loading && !paymentRequests ? "…" : metrics.totalProducts}
          </div>
        </div>

        {/* Total Pieces Card */}
        <div className="pickup-metric-card">
          <div className="pickup-metric-header">
            <span className="pickup-metric-title">
              {lang === "ar" ? "إجمالي القطع" : "Total Pieces"}
            </span>
            <div
              className="pickup-metric-icon-box"
              style={{
                backgroundColor: "rgba(16, 185, 129, 0.15)",
                color: "#10b981",
              }}
            >
              <LuTrendingUp size={20} />
            </div>
          </div>
          <div className="pickup-metric-value">
            {loading && !paymentRequests ? "…" : metrics.totalPieces}
          </div>
        </div>
      </div>

      {/* Main Table Card */}
      {paymentRequests && (
        <PaymentRequestsTableRow
          payments_list={paymentRequests}
          handleLoader={handleLoader}
          counter={counter}
        />
      )}
    </div>
  );
};

export default PickupReport;
